export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      films: "Pellicules",
      services: "Services",
      about: "À propos",
      contact: "Contact",
      cta: "Estimation gratuite",
    },
    menu: {
      title: "Menu",
      close: "Fermer le menu",
    },
    footer: {
      tagline:
        "Pellicules réfléchissantes haute performance pour maisons et entreprises au Québec. Confort, intimité et économies d'énergie, sans changer vos fenêtres.",
      hours: "Lun. – Ven. 8h – 18h",
      city: "Montréal, QC",
      rights: "Reflectum Pellicule. Tous droits réservés.",
      privacy: "Politique de confidentialité",
      badge: "Entreprise québécoise",
      contactLink: "Contact",
      wholesaleText: "Vous êtes installateur ou entrepreneur ?",
      wholesaleLink: "Voir l'offre grossiste",
      areas: "Montréal · Rive-Nord · Rive-Sud",
    },
    hero: {
      eyebrow: "Entreprise québécoise",
      pills: ["Contrôle de température", "Contrôle solaire", "Anti-regard"],
      title1: "Régule la température.",
      title2: "Zéro regard de vos voisins.",
      subtitle:
        "Pellicule réfléchissante installée en quelques heures à Montréal, sur la Rive-Nord et la Rive-Sud. Vous n'avez rien à faire.",
      cta: "Obtenir mon estimation gratuite",
      callCta: "438 255 6438",
      areas: "Montréal · Rive-Nord · Rive-Sud",
      reassurance: "Réponse en moins de 24 h • Sans engagement",
      satisfaction: "Pas satisfait ? On revient corriger sans frais.",
      rating: "5.0/5 · 16 avis sur Google",
    },
    benefitsBar: {
      items: [
        { title: "Prix clair avant les travaux", text: "On mesure, on évalue, puis on vous remet un prix ferme et détaillé, aucune surprise en cours de route." },
        { title: "Installation propre, point", text: "Finition sans bulles et chantier respecté. Pas satisfait ? On revient corriger sans frais." },
        { title: "Des conseils honnêtes, sans pression", text: "On vous dit franchement quelle pellicule convient, et quand ce n'est pas nécessaire." },
      ],
    },
    solutions: {
      eyebrow: "Nos solutions",
      title: "Pour chaque problème, une solution.",
      text: "Chaleur, regards indiscrets, bris de verre : choisissez votre situation, on vous montre la pellicule qui la règle.",
      more: "En savoir plus",
      categories: [
        {
          id: "chaleur",
          label: "Chaleur & éblouissement",
          cards: [
            { title: "Pellicule miroir", text: "Rejette jusqu'à 83 % de la chaleur solaire et réduit l'éblouissement, tout en bloquant les regards le jour.", to: "/pellicule-miroir", image: "/images/miroir-effet.webp" },
          ],
        },
        {
          id: "intimite",
          label: "Intimité",
          cards: [
            { title: "Pellicule miroir, le jour", text: "Effet réfléchissant : vous voyez dehors, personne ne voit dedans tant qu'il fait jour.", to: "/pellicule-miroir", image: "/images/apres-1.webp" },
            { title: "Pellicule givrée, en tout temps", text: "Fini dépoli qui masque les regards jour et nuit, tout en laissant passer la lumière.", to: "/pellicule-givree", image: "/images/givre-hero.webp" },
          ],
        },
        {
          id: "securite",
          label: "Sécurité",
          cards: [
            { title: "Pellicule de sécurité", text: "Pellicule transparente qui renforce la vitre et retient les éclats de verre en cas de bris.", to: "/pellicules/securite", image: "/images/securite-commerce.webp" },
          ],
        },
      ],
    },
    work: {
      eyebrow: "Nos réalisations",
      title: "Des projets réels, partout dans la région.",
      alts: [
        "Grande fenêtre résidentielle avec pellicule miroir posée par Reflectum", "Fenêtres à effet miroir vues de l'extérieur, les regards sont bloqués", "Fenêtre avec pellicule givrée, intimité dans une pièce lumineuse", "Grande fenêtre avec pellicule sur une maison moderne, réalisation Reflectum", "Fenêtres à effet miroir sur une résidence, les regards sont bloqués", "Façade complète avec pellicules miroir, projet Reflectum",
      ],
    },
    homeForm: {
      eyebrow: "Estimation gratuite",
      title: "Parlez-nous de vos fenêtres.",
      text: "Remplissez le formulaire, un membre de notre équipe vous contacte sous 24 à 48 heures avec une évaluation personnalisée, sans engagement.",
    },
    proof: {
      eyebrow: "La preuve en images",
      title: "Avant. Après. En quelques heures.",
      text: "De vraies résidences, de vrais résultats : des fenêtres qu'on voyait à travers, transformées en miroir impeccable. Et sur la vidéo, la finition de près, zéro bulle, zéro décollement.",
      before: "Avant",
      after: "Après",
      alts: [
        ["Fenêtres sans pellicule, on voit directement à l'intérieur de la résidence", "Les mêmes fenêtres avec pellicule miroir, effet réfléchissant, intimité de jour"],
        ["Fenêtres avant la pose, vue claire vers l'intérieur", "Fenêtres après la pose, effet miroir, regards bloqués"],
      ],
    },
    reviews: {
      eyebrow: "Avis clients",
      title: "Ce que disent nos clients.",
      leaveReview: "Laisser un avis sur Google",
      seeMore: "Voir plus",
      seeLess: "Voir moins",
      unit: "avis",
      onGoogle: "16 avis sur Google",
      emptyTitle: "Retrouvez tous nos avis sur Google.",
      emptyText:
        "Cliquez ci-dessous pour lire les avis de nos clients ou pour partager votre expérience.",
      emptyCta: "Voir / laisser un avis sur Google",
    },
    problem: {
      eyebrow: "Le problème que nous résolvons",
      title: "Vos fenêtres laissent passer bien plus que la lumière.",
      text: "Chaleur excessive, factures de climatisation qui grimpent, meubles qui décolorent, voisins qui voient tout. Remplacer vos fenêtres coûte cher, souvent 15 000 $ ou plus.",
      bullets: [
        "Rejette jusqu'à 83% de la chaleur solaire l'été", "Pas besoin de nouveaux thermos qui coûtent une fortune", "Effet miroir pour une intimité totale le jour", "Réduit l'éblouissement sur écrans et téléviseurs", "Protection contre les rayons UV, meubles et planchers protégés",
      ],
      cta: "Discutons de votre projet",
    },
    process: {
      eyebrow: "Comment ça marche",
      title: "Un service clé en main, propre et rapide.",
      steps: [
        { n: "01", t: "Estimation gratuite", d: "Nous évaluons vos fenêtres, vos objectifs et proposons la pellicule idéale." },
        { n: "02", t: "Devis clair", d: "Prix fixe, sans surprises. Vous validez, on planifie l'installation." },
        { n: "03", t: "Installation propre", d: "Service clé en main, précis et rapide. Aucun dégât, aucune poussière." },
        { n: "04", t: "Confort immédiat", d: "Dès la pose, vous ressentez moins de chaleur, plus d'intimité, moins d'éblouissement." },
      ],
    },
    segments: {
      residential: {
        title: "Résidentiel",
        heading: "Pour vos espaces résidentiels",
        desc: "Maisons, condos, chalets. Retrouvez le confort chez vous : moins de chaleur, plus d'intimité, pas de regards depuis la rue ou les voisins.",
        cta: "Estimation résidentielle",
      },
      commercial: {
        title: "Commercial",
        heading: "Pour vos espaces commerciaux",
        desc: "Bureaux, commerces, cliniques. Améliorez le confort des employés, éliminez les reflets sur les écrans et projetez une image professionnelle.",
        cta: "Estimation commerciale",
      },
    },
    finalCta: {
      eyebrow: "Prêt à commencer ?",
      title: "Obtenez votre estimation gratuite en 24 heures.",
      text: "Sans engagement. Un membre de notre équipe vous contacte, évalue vos besoins et vous propose un devis clair.",
      button: "Obtenir mon estimation gratuite",
    },
    faq: {
      eyebrow: "Questions fréquentes",
      title: "Tout ce qu'il faut savoir avant de vous lancer.",
      items: [
        {
          q: "Quel est le prix d'une installation ?",
          a: "Le coût dépend surtout de la surface de vitrage à couvrir et du type de pellicule choisi. Nos tarifs surprennent agréablement la plupart de nos clients. Pour un chiffre précis, remplissez notre formulaire : l'estimation est 100 % gratuite et sans engagement.",
        },
        {
          q: "Combien de temps prend l'installation ?",
          a: "La plupart des résidences sont complétées en une seule journée. Pour les commerces et bureaux, on planifie la pose hors de vos heures d'ouverture pour ne pas déranger vos opérations.",
        },
        {
          q: "Et si je ne suis pas satisfait du résultat ?",
          a: "On revient, point. Si quoi que ce soit ne vous satisfait pas après l'installation, on corrige sans frais.",
        },
        {
          q: "Dans quelles régions offrez-vous vos services ?",
          a: "Nous desservons Montréal, la Rive-Nord et la Rive-Sud. Écrivez-nous pour confirmer votre secteur, l'estimation reste gratuite.",
        },
        {
          q: "Est-ce que ça fonctionne la nuit ?",
          a: "L'effet miroir suit une règle simple : il faut plus de lumière à l'extérieur qu'à l'intérieur. Le soir, si vos pièces sont éclairées, l'effet s'estompe. Tamiser l'éclairage intérieur ou orienter un éclairage extérieur vers les fenêtres aide à préserver l'intimité. Pour une tranquillité absolue, fermez stores ou rideaux le soir, ou optez pour la pellicule givrée, qui assure une intimité totale 24 h sur 24.",
        },
      ],
      more: "Une autre question ?",
      moreLink: "Écrivez-nous, on répond en moins de 24 h",
    },
    faqMore: {
      eyebrow: "Questions fréquentes",
      title: "Les autres réponses.",
      items: [
        {
          q: "Combien de temps dure une pellicule réfléchissante ?",
          a: "Nos pellicules professionnelles durent 15 ans et plus. Elles ne jaunissent pas, ne bullent pas et ne décollent pas.",
        },
        {
          q: "Est-ce que mes vitres s'entretiennent comme avant ?",
          a: "Oui. Après une période de cure d'environ 30 jours, vous nettoyez vos fenêtres normalement avec un chiffon doux et un nettoyant sans abrasif. Aucun entretien spécial n'est requis.",
        },
        {
          q: "Comment ça paraît de l'intérieur ?",
          a: "Le jour, la pellicule miroir peut laisser un léger reflet bleuté ou argenté selon le modèle. L'effet est discret et vos pièces conservent leur luminosité, vous voyez dehors, on ne vous voit pas.",
        },
        {
          q: "Est-ce que l'effet miroir fonctionne aussi la nuit ?",
          a: "L'effet miroir suit une règle simple : il faut plus de lumière à l'extérieur qu'à l'intérieur. Le soir, si vos pièces sont éclairées, l'effet s'estompe. Tamiser l'éclairage intérieur ou orienter un éclairage extérieur vers les fenêtres aide à préserver l'intimité. Pour une tranquillité absolue, fermez stores ou rideaux le soir, ou optez pour la pellicule givrée, qui assure une intimité totale 24 h sur 24.",
        },
        {
          q: "Est-ce compatible avec mes thermos (vitrages scellés) ?",
          a: "Ça dépend du type de vitrage : sur certains verres, une pellicule solaire peut créer un risque de choc thermique. C'est pourquoi nous évaluons la compatibilité de chaque fenêtre avant la pose, et nous vous informons de tout risque avant de commencer.",
        },
      ],
    },
    sticky: "Estimation gratuite",
    meta: {
      pages: {
        home: { title: "Reflectum Pellicule, Pellicules réfléchissantes | Montréal", desc: "Pellicules réfléchissantes à Montréal : intimité de jour, jusqu'à 83 % de chaleur solaire rejetée et une protection contre les UV. Estimation gratuite en 24 h." },
        films: { title: "Nos pellicules, Miroir, givrée et sécurité | Reflectum Pellicule", desc: "Trois pellicules pour vos fenêtres : miroir pour le jour, givrée pour jour et nuit, sécurité pour renforcer le verre. Découvrez celle qu'il vous faut." },
        miroir: { title: "Pellicule miroir, Intimité de jour | Reflectum Pellicule", desc: "Effet miroir élégant : intimité totale de jour, jusqu'à 83% de chaleur solaire rejetée et une protection contre les UV. Installation professionnelle à Montréal." },
        givre: { title: "Pellicule givrée, Intimité 24 h | Reflectum Pellicule", desc: "Fini dépoli élégant qui laisse passer la lumière tout en masquant les regards, jour et nuit. Salles de bain, bureaux, cloisons, vitrines." },
        securite: { title: "Pellicule de sécurité, Vitres renforcées | Reflectum Pellicule", desc: "Pellicule de sécurité transparente à Montréal : retient les éclats de verre, renforce les vitres contre les bris et les intrusions. Estimation gratuite." },
        services: { title: "Services résidentiels et commerciaux | Reflectum Pellicule", desc: "Installation de pellicules pour fenêtres résidentielles et commerciales à Montréal : service clé en main et propre. Estimation gratuite." },
        about: { title: "À propos de Reflectum Pellicule, Montréal", desc: "Une entreprise québécoise : des pellicules réfléchissantes haute performance, posées avec la précision d'un artisan." },
        contact: { title: "Estimation gratuite en 24 h | Reflectum Pellicule", desc: "Demandez votre estimation gratuite : un membre de notre équipe vous contacte sous 24 à 48 heures. Sans engagement, à Montréal et environs." },
        privacy: { title: "Politique de confidentialité | Reflectum Pellicule", desc: "Comment Reflectum Pellicule recueille, utilise et protège vos renseignements personnels, conformément à la Loi 25." },
        wholesale: { title: "Grossiste pellicule fenêtre Québec | Reflectum Pellicule", desc: "Grossiste de pellicules pour fenêtres au Québec : rouleaux Reflectum Silver 20 % et 35 % à 450 $ (500 pi², 0,90 $/pi²). Stock au Québec, prix transparent." },
      },
    },
    wholesale: {
      nav: "Pro / Grossiste",
      bannerText: "Vous êtes installateur, vitrier ou entrepreneur ? Découvrez nos prix grossiste.",
      bannerCta: "Voir l'offre grossiste",
      eyebrow: "Pro / Grossiste",
      heroTitle: "Le fournisseur de pellicules pour les pros du Québec.",
      heroSubtitle: "Prix transparent, stock au Québec.",
      heroStats: [
        { v: "0,90 $", l: "par pi², Silver 20 % et 35 %" },
        { v: "500 pi²", l: "par rouleau, 60 po x 100 pi" },
        { v: "En stock", l: "au Québec" },
      ],
      heroCta: "Commander / Demander une soumission",
      forWhomEyebrow: "Pour qui",
      forWhom: [
        "Installateurs de pellicules", "Vitriers", "Entrepreneurs en construction et rénovation", "Designers", "Détaillants",
      ],
      productsEyebrow: "Nos rouleaux",
      productsTitle: "Pellicule anti-chaleur, UV et intimité",
      formatLabel: "Format",
      orderCta: "Commander / Demander une soumission",
      products: [
        {
          name: "Reflectum Silver 20 %",
          tagline: "Intimité complète de jour (effet miroir très prononcé)",
          format: "Rouleau 60 po x 100 pi (500 pi²)",
          price: "450 $ le rouleau (soit 0,90 $/pi²)",
          specs: [
            "Énergie solaire totale rejetée (ESTR) : environ 77 à 80 %, très haute protection thermique", "Réflexion lumineuse extérieure : environ 57 %", "Réduction de l'éblouissement : environ 78 à 82 %", "Protection contre les rayons UV",
          ],
        },
        {
          name: "Reflectum Silver 35 %",
          tagline: "Teinte plus légère : plus de lumière naturelle, effet miroir plus discret",
          format: "Rouleau 60 po x 100 pi (500 pi²)",
          price: "450 $ le rouleau (soit 0,90 $/pi²)",
          specs: [
            "Énergie solaire totale rejetée (ESTR) : environ 63 à 65 %, protection thermique modérée", "Réflexion lumineuse extérieure : environ 39 %", "Réduction de l'éblouissement : environ 62 à 63 %", "Protection contre les rayons UV",
          ],
        },
      ],
      compareTitle: "Silver 20 % ou Silver 35 % ?",
      compareNote: "Valeurs approximatives mesurées sur le film seul. Les résultats varient selon le type de vitrage.",
      nightNote: "L'effet miroir protège l'intimité de jour ; la nuit, avec la lumière à l'intérieur, l'effet s'inverse.",
      compareRows: [
        { label: "Prix par rouleau", a: "450 $ (0,90 $/pi²)", b: "450 $ (0,90 $/pi²)" },
        { label: "Énergie solaire totale rejetée (ESTR)", a: "≈ 77–80 %", b: "≈ 63–65 %" },
        { label: "Réflexion lumineuse extérieure", a: "≈ 57 %", b: "≈ 39 %" },
        { label: "Réduction de l'éblouissement", a: "≈ 78–82 %", b: "≈ 62–63 %" },
        { label: "Protection contre les rayons UV", a: "Oui", b: "Oui" },
        { label: "Effet miroir", a: "Très prononcé", b: "Plus discret" },
        { label: "Usage idéal", a: "Plein sud/ouest, verrières, surchauffe", b: "Luminosité maximale, chaleur modérée" },
      ],
      chooseEyebrow: "Quel film choisir ?",
      choose20Title: "Choisissez le Silver 20 % si :",
      choose20: [
        "La fenêtre est exposée plein sud ou plein ouest, ou c'est une verrière", "La surchauffe est votre priorité numéro un", "Vous voulez un maximum d'intimité de jour, avec un effet miroir bien visible de l'extérieur", "Vous acceptez un rendu plus sombre, comparable à des lunettes de soleil",
      ],
      choose35Title: "Choisissez le Silver 35 % si :",
      choose35: [
        "Vous voulez garder le plus de lumière naturelle possible à l'intérieur", "Vous préférez un effet miroir plus discret de l'extérieur", "La chaleur est un enjeu modéré (protection thermique moyenne, bonne réduction de l'éblouissement)", "Précision honnête : l'intimité est bonne de jour, mais dans une pièce très éclairée ou près de la vitre, on peut deviner des silhouettes de l'extérieur",
      ],
      chooseHelp: "Pas sûr de votre choix ? Contactez-nous, on vous conseille selon l'orientation et l'usage de vos fenêtres.",
      advantagesEyebrow: "Avantages grossiste",
      advantages: ["Prix transparent", "Stock au Québec", "Support technique"],
      faqEyebrow: "Questions fréquentes",
      faq: [
        { q: "Quelle est la commande minimale ?", a: "Écrivez-nous avec vos quantités, on vous confirme rapidement les modalités selon le produit." },
        { q: "Livrez-vous, ou faut-il ramasser ?", a: "Le stock est au Québec. Les options de livraison ou de ramassage sont confirmées avec vous au moment de la commande." },
        { q: "Offrez-vous des échantillons ?", a: "Écrivez-nous à contact@reflectumpellicule.com avec le produit qui vous intéresse et on verra ce qu'on peut faire pour vous." },
        { q: "Quels sont les modes de paiement ?", a: "Les modalités de paiement sont précisées clairement sur la soumission, avant toute commande." },
      ],
      formTitle: "Commander / Demander une soumission",
      formSubtitle: "Remplissez le formulaire, on vous répond avec un prix ferme et les disponibilités.",
      form: {
        name: "Nom complet *",
        namePlaceholder: "Jean Tremblay",
        company: "Entreprise *",
        companyPlaceholder: "Vitrerie ABC inc.",
        companyType: "Type d'entreprise *",
        companyTypes: ["Installateur de pellicules", "Vitrier", "Entrepreneur en construction / rénovation", "Designer", "Détaillant", "Autre"],
        neq: "NEQ (facultatif)",
        neqPlaceholder: "1234567890",
        email: "Courriel *",
        emailPlaceholder: "jean@entreprise.com",
        phone: "Téléphone *",
        phonePlaceholder: "(514) 555-1234",
        city: "Ville",
        cityPlaceholder: "Montréal",
        product: "Produit *",
        productOptions: ["Reflectum Silver 20 %", "Reflectum Silver 35 %", "Les deux"],
        rolls: "Nombre de rouleaux *",
        message: "Message (facultatif)",
        messagePlaceholder: "Quantités, délais souhaités, questions...",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours...",
        select: "Sélectionnez...",
        errorRequired: "Veuillez remplir tous les champs obligatoires.",
        successToast: "Demande envoyée ! On vous répond rapidement.",
        errorToast: "Erreur lors de l'envoi. Réessayez ou appelez-nous.",
        errorGeneric: "Erreur lors de l'envoi.",
        successTitle: "Demande envoyée !",
        successText: "Merci ! Notre équipe vous répond rapidement avec un prix ferme et les disponibilités.",
        successAnother: "Envoyer une autre demande",
      },
    },
    films: {
      eyebrow: "Nos pellicules",
      title: "Trois pellicules. Trois réponses pour vos fenêtres.",
      subtitle: "Miroir, givrée ou sécurité : chaque pellicule répond à un besoin précis. Découvrez celle qui convient à vos fenêtres.",
      miroirCard: {
        label: "Pellicule miroir",
        short: "Effet réfléchissant de jour : les regards restent dehors, la chaleur et les UV aussi.",
        cta: "Découvrir la pellicule miroir",
      },
      givreCard: {
        label: "Pellicule givrée",
        short: "Fini dépoli élégant : intimité totale jour et nuit, lumière naturelle préservée.",
        cta: "Découvrir la pellicule givrée",
      },
      securiteCard: {
        label: "Pellicule de sécurité",
        short: "Pellicule transparente qui renforce la vitre et retient les éclats de verre en cas de bris.",
        cta: "Découvrir la pellicule de sécurité",
      },
      benefitsEyebrow: "Les avantages",
      idealEyebrow: "Idéal pour",
      galleryEyebrow: "Exemples d'installations",
      noteEyebrow: "Bon à savoir",
      thumbAlt: "exemple",
      ctaEyebrow: "Estimation gratuite",
      ctaTitle: "Voyez ce que ça donnerait chez vous.",
      ctaText: "Un membre de notre équipe évalue vos fenêtres et vous propose un prix clair, sans engagement.",
      ctaButton: "Obtenir mon estimation gratuite",
      backTo: "Voir toutes les pellicules",
      miroirPage: {
        eyebrow: "Pellicule miroir",
        title: "L'effet miroir. L'intimité totale, chaque jour.",
        intro: "De l'extérieur, vos fenêtres deviennent un miroir élégant qui bloque tous les regards. De l'intérieur, la vue reste claire et lumineuse. C'est notre solution la plus populaire pour les façades exposées, les grandes fenêtres et les portes vitrées.",
        benefits: [
          "Intimité totale de jour, personne ne voit à l'intérieur", "Rejette jusqu'à 83% de la chaleur solaire l'été", "Protection contre les rayons UV, meubles et planchers protégés", "Réduit l'éblouissement sur les écrans et téléviseurs", "Vue claire préservée de l'intérieur, sans assombrir vos pièces",
        ],
        ideal: [
          "Façades exposées au soleil", "Grandes fenêtres et baies vitrées", "Portes vitrées et solariums", "Bureaux et commerces en plain-pied",
        ],
        note: "L'effet miroir fonctionne le jour, quand il fait plus clair dehors qu'à l'intérieur. Le soir, on recommande de fermer stores ou rideaux, ou de combiner avec une pellicule givrée pour une intimité 24 h sur 24.",
      },
      givrePage: {
        eyebrow: "Pellicule givrée",
        title: "L'intimité douce. Jour et nuit, sans exception.",
        intro: "Un fini dépoli élégant qui laisse passer la lumière naturelle tout en masquant complètement les regards, le jour comme la nuit. La pellicule givrée est la solution idéale là où l'intimité ne doit jamais faiblir.",
        benefits: [
          "Intimité complète 24 h sur 24, jour et nuit", "Laisse passer la lumière naturelle, pièces lumineuses", "Fini dépoli moderne et discret, aspect haut de gamme", "Masque les regards sans rideaux ni stores", "Parfaite pour salles de bain, chambres et espaces de travail", "Entretien facile et durable",
        ],
        ideal: [
          "Salles de bain et chambres", "Portes d'entrée vitrées", "Bureaux, cliniques et salles de conférence", "Cloisons intérieures et vitrines commerciales",
        ],
        note: "La pellicule givrée diffuse la lumière au lieu de la bloquer. Résultat : une pièce lumineuse, mais totalement privée, même les lumières allumées le soir.",
      },
      securitePage: {
        eyebrow: "Pellicule de sécurité",
        title: "Une vitre renforcée. Des éclats retenus.",
        intro: "La pellicule de sécurité est une pellicule transparente qui renforce la vitre et la garde en place en cas de bris. Elle retient les éclats de verre, rend les vitres plus difficiles à fracasser, ce qui dissuade les intrusions et les vols éclair, et protège contre les bris accidentels ou causés par les tempêtes.",
        benefits: [
          "Retient les éclats de verre en cas de bris", "Vitres plus difficiles à fracasser, dissuade les intrusions et les vols éclair", "Protège contre les bris accidentels ou causés par les tempêtes", "Transparente, ne change ni la lumière ni l'apparence", "Se combine avec la pellicule miroir ou l'anti-UV",
        ],
        ideal: [
          "Portes vitrées et fenêtres du rez-de-chaussée", "Vitrines de commerces et bureaux en plain-pied", "Fenêtres près des aires de jeu", "Zones exposées aux tempêtes et aux vents violents",
        ],
        note: null,
      },
    },
    cities: {
      eyebrow: "Secteurs desservis",
      cta: "Estimation gratuite dans mon secteur",
      items: {
        montreal: {
          name: "Montréal",
          title: "Installation de pellicule pour fenêtres à Montréal.",
          intro: "Condo au centre-ville, duplex du Plateau ou maison de ville : à Montréal, les fenêtres donnent souvent sur la rue, et le soleil d'été tape fort. Nos pellicules réfléchissantes gardent vos pièces confortables et les regards à l'extérieur, sans changer vos fenêtres.",
          points: [
            "Intimité de jour même au rez-de-chaussée, face à la rue", "Jusqu'à 83% de chaleur solaire rejetée, un vrai plus pendant les canicules", "Protection contre les rayons UV : planchers, meubles et rideaux protégés", "Option givrée pour une intimité jour et nuit (salle de bain, entrée)",
          ],
          metaDesc: "Installation de pellicules réfléchissantes à Montréal : intimité de jour, jusqu'à 83% de chaleur solaire rejetée et une protection contre les UV. Estimation gratuite.",
        },
        laval: {
          name: "Laval",
          title: "Installation de pellicule pour fenêtres à Laval.",
          intro: "Entre Montréal et la couronne nord, Laval regroupe de vastes quartiers résidentiels où les maisons comptent de grandes fenêtres exposées au soleil, et où la chaleur comme les regards deviennent vite un problème l'été. Reflectum Pellicule installe ses pellicules réfléchissantes et givrées partout en ville : bungalows, condos, propriétés riveraines et commerces.",
          points: [
            "Maisons et bungalows : intimité de jour dans les pièces qui donnent sur la rue", "Jusqu'à 83% de chaleur solaire rejetée sur les grandes fenêtres exposées", "Protection contre les UV : planchers et meubles protégés de la décoloration", "Pellicule givrée pour cloisons, salles de bain et vitrines de commerces",
          ],
          metaDesc: "Installation de pellicules pour fenêtres à Laval : intimité de jour, jusqu'à 83% de chaleur rejetée et une protection contre les UV. Estimation gratuite en 24 h.",
        },
        longueuil: {
          name: "Longueuil",
          title: "Installation de pellicule pour fenêtres à Longueuil.",
          intro: "Au cœur de la Rive-Sud, Longueuil combine des quartiers résidentiels établis et un centre-ville en pleine effervescence. Les fenêtres exposées plein sud et les portes-patio y laissent entrer une chaleur intense l'été. Reflectum Pellicule y installe des pellicules réfléchissantes et givrées, pour les résidences comme pour les commerces et les bureaux.",
          points: [
            "Résidences : intimité de jour avec le miroir, ou jour et nuit avec la givrée", "Jusqu'à 83% de chaleur solaire rejetée, pièces confortables pendant les canicules", "Bureaux et commerces : éblouissement réduit sur les écrans, marchandise protégée des UV", "Service clé en main, propre et soigné",
          ],
          metaDesc: "Pellicules pour fenêtres à Longueuil, résidentiel et commercial : miroir, anti-chaleur, anti-UV, givrée. Estimation gratuite et sans engagement.",
        },
        brossard: {
          name: "Brossard",
          title: "Installation de pellicule pour fenêtres à Brossard.",
          intro: "Brossard ne cesse de croître : maisons récentes aux grandes surfaces vitrées, condos lumineux et commerces achalandés. Ces belles fenêtres laissent entrer beaucoup de chaleur, et de regards indiscrets. Reflectum Pellicule y pose des pellicules réfléchissantes et givrées, en résidentiel comme en commercial, avec la même promesse partout : installation propre et estimation gratuite.",
          points: [
            "Maisons récentes et condos : les grandes surfaces vitrées gagnent en confort", "Jusqu'à 83% de chaleur solaire rejetée, sans assombrir vos pièces", "Pellicule givrée pour portes d'entrée, salles de bain et bureaux", "Protection contre les UV : planchers de bois et meubles neufs protégés",
          ],
          metaDesc: "Pellicules réfléchissantes et givrées à Brossard : intimité, chaleur rejetée jusqu'à 83% et protection contre les UV. Estimation gratuite en 24 à 48 h.",
        },
        "rive-nord": {
          name: "Rive-Nord",
          title: "Installation de pellicule pour fenêtres sur la Rive-Nord.",
          intro: "De Laval à Terrebonne, les maisons de la Rive-Nord ont de grandes fenêtres, des portes-patio et des vérandas plein soleil. Nos pellicules réduisent la surchauffe l'été et vous redonnent de l'intimité, sans toucher à vos fenêtres.",
          points: [
            "Idéal pour vérandas, solariums et portes-patio exposées", "Jusqu'à 83% de chaleur solaire rejetée", "Effet miroir le jour : on ne voit plus à l'intérieur depuis la rue ou la cour", "Option givrée pour une intimité jour et nuit",
          ],
          metaDesc: "Pellicules réfléchissantes sur la Rive-Nord (Laval, Terrebonne et environs) : intimité, chaleur rejetée jusqu'à 83% et protection contre les UV. Estimation gratuite.",
        },
        "rive-sud": {
          name: "Rive-Sud",
          title: "Installation de pellicule pour fenêtres sur la Rive-Sud.",
          intro: "De Longueuil à Brossard, les bungalows et cottages de la Rive-Sud profitent d'une belle lumière, parfois trop. Nos pellicules réfléchissantes coupent l'éblouissement et la chaleur tout en gardant vos pièces lumineuses.",
          points: [
            "Moins d'éblouissement sur les écrans et téléviseurs", "Jusqu'à 83% de chaleur solaire rejetée", "Intimité de jour avec effet miroir, ou pellicule givrée 24 h/24", "Estimation gratuite à domicile partout sur la Rive-Sud",
          ],
          metaDesc: "Pellicules réfléchissantes sur la Rive-Sud (Longueuil, Brossard et environs) : anti-éblouissement, chaleur rejetée jusqu'à 83%, intimité. Estimation gratuite.",
        },
      },
    },
    services: {
      eyebrow: "Nos services",
      title: "Une pellicule pour chaque besoin.",
      subtitle:
        "Résidentiel ou commercial, ancien ou moderne, nous avons la solution adaptée à vos fenêtres. Chaque projet est unique, chaque estimation est gratuite.",
      residential: {
        eyebrow: "Résidentiel",
        title: "Confort et intimité à la maison",
        desc: "Maisons, condos, chalets, portes vitrées. Reprenez le contrôle de votre lumière, de votre température intérieure et de votre vie privée face au voisinage.",
        bullets: [
          "Fenêtres de façade et de côté", "Solariums et vérandas", "Portes-fenêtres et baies vitrées", "Puits de lumière",
        ],
      },
      commercial: {
        eyebrow: "Commercial",
        title: "Productivité et image professionnelle",
        desc: "Bureaux, commerces, cliniques, restaurants. Créez un environnement confortable pour vos employés et vos clients tout en réduisant vos coûts énergétiques.",
        bullets: [
          "Vitrines commerciales", "Immeubles de bureaux", "Cliniques et cabinets", "Cloisons vitrées intérieures",
        ],
      },
      included: {
        eyebrow: "Service clé en main",
        title: "Ce qui est toujours inclus.",
        text: "Pas de coûts cachés, pas de surprises. Un projet propre et précis.",
        cta: "Obtenir mon estimation gratuite",
        items: [
          "Consultation gratuite à domicile ou au bureau", "Mesures précises et devis détaillé sans engagement", "Fourniture de pellicules haute performance", "Installation professionnelle par notre équipe formée", "Nettoyage complet des surfaces après pose",
        ],
      },
    },
    about: {
      eyebrow: "Notre histoire",
      title: "L'énergie de la relève, la précision d'un artisan.",
      intro:
        "Reflectum Pellicule est né d'une idée simple : rendre les pellicules réfléchissantes haute performance accessibles à tous les Québécois. Sans les prix gonflés d'une rénovation majeure.",
      cta: "Travaillez avec nous",
      quote: "« Nos fenêtres, réinventées. »",
      quoteBy: "L'équipe Reflectum",
      story: {
        eyebrow: "Notre histoire",
        title: "Une idée, devenue une passion.",
        paragraphs: [
          "Tout a commencé par une idée toute simple.", "On cherchait un projet concret pour tester notre ambition. Un jour d'été, étouffés par la chaleur et fatigués du manque d'intimité chez nous, on a eu le déclic : il fallait une solution simple et efficace.", "L'idée des films réfléchissants était née.", "Ce qui n'était qu'une simple discussion s'est transformé en obsession. On a testé des matériaux, perfectionné notre technique et lancé Reflectum.", "Aujourd'hui, on ne fait pas que poser des pellicules : on coupe la chaleur et on protège votre intimité.", "On est partis d'une simple idée, et ce n'est que le début.",
        ],
      },
      values: {
        eyebrow: "Nos valeurs",
        title: "Ce qui nous distingue.",
        items: [
          {
            title: "Entreprise québécoise",
            desc: "Une équipe québécoise motivée, formée et supervisée. Nous mettons notre énergie et notre sérieux au service de votre projet.",
          },
          {
            title: "Fièrement québécoise",
            desc: "Nous connaissons les hivers rigoureux, les étés chauds et humides, et l'importance du confort dans votre chez-vous. Une solution pensée pour ici.",
          },
          {
            title: "Précision d'artisan",
            desc: "Chaque installation est mesurée, découpée et posée avec un souci du détail digne d'un artisan. Zéro bulle, zéro poussière, zéro dégât.",
          },
          {
            title: "Prix justes, service pro",
            desc: "Nous offrons un tarif compétitif. Vous économisez et vous gagnez en confort.",
          },
        ],
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Obtenir mon estimation gratuite.",
      subtitle:
        "Remplissez le formulaire ci-dessous. Un membre de notre équipe vous contacte sous 24 à 48 heures avec une évaluation personnalisée, sans engagement.",
      info: {
        email: "Courriel",
        phone: "Téléphone",
        area: "Zone de service",
        areaValue: "Montréal, Rive-Nord et Rive-Sud",
        hours: "Heures d'ouverture",
        hoursValue: "Lun. – Ven. 8h – 18h",
        fastEyebrow: "Rapide",
        fastTitle: "Réponse sous 24-48h",
        fastText: "Toutes les demandes reçoivent une confirmation immédiate par courriel.",
      },
      form: {
        name: "Nom complet *",
        namePlaceholder: "Jean Tremblay",
        email: "Courriel *",
        emailPlaceholder: "jean@exemple.com",
        phone: "Téléphone *",
        phonePlaceholder: "(514) 555-1234",
        address: "Adresse (optionnel)",
        addressPlaceholder: "Ville ou adresse complète",
        propertyType: "Type de propriété *",
        select: "Sélectionnez...",
        residential: "Résidentiel",
        commercial: "Commercial",
        windowCount: "Nombre approximatif de fenêtres",
        windows: ["1 à 3 fenêtres", "4 à 8 fenêtres", "9 à 15 fenêtres", "16 et plus"],
        bestTime: "Meilleur moment pour vous contacter",
        times: [
          { label: "AM", sub: "9h – 12h" },
          { label: "Début PM", sub: "13h – 17h" },
          { label: "Fin PM", sub: "17h – 18h" },
        ],
        message: "Message (optionnel)",
        messagePlaceholder:
          "Décrivez brièvement votre besoin, orientation des fenêtres, contraintes particulières...",
        submit: "Envoyer ma demande",
        sending: "Envoi en cours...",
        legal:
          "En soumettant ce formulaire, vous acceptez d'être contacté au sujet de votre projet. Nous ne partageons jamais vos informations avec des tiers.",
        errorRequired: "Veuillez remplir tous les champs obligatoires.",
        successToast: "Demande envoyée ! Nous vous contactons sous 24-48h.",
        errorToast: "Erreur lors de l'envoi. Réessayez ou appelez-nous.",
        errorGeneric: "Erreur lors de l'envoi.",
        successTitle: "Demande envoyée !",
        successText:
          "Merci pour votre confiance. Un membre de notre équipe vous contactera sous 24 à 48 heures avec votre estimation personnalisée.",
        successAnother: "Envoyer une autre demande",
      },
    },
    privacy: {
      eyebrow: "Confidentialité",
      title: "Politique de confidentialité",
      updated: "Dernière mise à jour : ",
      blocks: [
        {
          title: "1. Qui nous sommes",
          body: [
            "Reflectum Pellicule (« nous », « notre », « nos ») est une entreprise québécoise spécialisée dans l'installation de pellicules réfléchissantes pour maisons et entreprises dans la région du Grand Montréal.", "Nous accordons une grande importance à la protection de vos renseignements personnels et nous nous engageons à respecter la Loi sur la protection des renseignements personnels dans le secteur privé (Loi 25) du Québec.",
          ],
        },
        {
          title: "2. Renseignements que nous recueillons",
          body: [
            "Lorsque vous soumettez un formulaire d'estimation ou de contact sur notre site, nous recueillons : vos nom et prénom, votre adresse courriel, votre numéro de téléphone, votre adresse postale ou ville (facultatif), le type de propriété (résidentiel ou commercial), le nombre de fenêtres approximatif, le moment préféré pour être contacté, ainsi que tout message que vous nous transmettez.", "Lorsque vous laissez un avis, nous recueillons votre nom, votre ville (facultatif), votre note et le texte de votre commentaire.",
          ],
        },
        {
          title: "3. Utilisation de vos renseignements",
          body: [
            "Vos renseignements personnels sont utilisés uniquement pour : vous fournir une estimation personnalisée pour votre projet, communiquer avec vous par courriel ou téléphone, planifier une visite d'évaluation ou une installation, effectuer le suivi de votre projet, et améliorer nos services en fonction de vos commentaires.", "Nous ne vendons, ne louons et ne partageons jamais vos renseignements avec des tiers à des fins commerciales.",
          ],
        },
        {
          title: "4. Publicités Facebook et Meta",
          body: [
            "Si vous nous contactez via une publicité Facebook ou Instagram (Meta), les renseignements que vous fournissez dans le formulaire nous sont transmis par Meta. Nous les utilisons uniquement pour donner suite à votre demande.", "La collecte de vos renseignements par Meta est régie par la politique de confidentialité de Meta.",
          ],
        },
        {
          title: "5. Conservation et sécurité",
          body: [
            "Vos renseignements sont conservés sur des serveurs sécurisés et protégés par des mesures techniques et organisationnelles raisonnables pour prévenir tout accès non autorisé.", "Nous conservons vos renseignements aussi longtemps que nécessaire pour vous fournir nos services et respecter nos obligations légales, généralement jusqu'à 3 ans après le dernier contact.",
          ],
        },
        {
          title: "6. Vos droits",
          body: [
            "Conformément à la Loi 25, vous avez le droit d'accéder aux renseignements personnels que nous détenons à votre sujet, de rectifier les renseignements inexacts, incomplets ou équivoques, de demander la suppression de vos renseignements, de retirer votre consentement à tout moment, et de déposer une plainte auprès de la Commission d'accès à l'information du Québec.", "Pour exercer ces droits, contactez-nous à contact@reflectumpellicule.com.",
          ],
        },
        {
          title: "7. Témoins (cookies)",
          body: [
            "Notre site utilise un minimum de témoins nécessaires à son bon fonctionnement (session de connexion admin, préférences d'affichage). Nous n'utilisons pas de témoins de suivi publicitaire tiers.",
          ],
        },
        {
          title: "8. Modifications de cette politique",
          body: [
            "Nous pouvons mettre à jour cette politique de confidentialité pour refléter des changements dans nos pratiques ou pour respecter de nouvelles obligations légales. Toute modification importante sera annoncée sur cette page avec la date de mise à jour.",
          ],
        },
        {
          title: "9. Responsable de la protection des renseignements personnels",
          body: [
            "Conformément à la Loi 25, notre responsable de la protection des renseignements personnels peut être joint aux coordonnées suivantes : Reflectum Pellicule, contact@reflectumpellicule.com, Grand Montréal, Québec, Canada, 438 255 6438.",
          ],
        },
      ],
    },
  },

  en: {
    nav: {
      home: "Home",
      films: "Films",
      services: "Services",
      about: "About",
      contact: "Contact",
      cta: "Free estimate",
    },
    menu: {
      title: "Menu",
      close: "Close menu",
    },
    footer: {
      tagline:
        "High-performance reflective window films for homes and businesses across Québec. Comfort, privacy and energy savings, without replacing your windows.",
      hours: "Mon. – Fri. 8am – 6pm",
      city: "Montreal, QC",
      rights: "Reflectum Pellicule. All rights reserved.",
      privacy: "Privacy Policy",
      badge: "Québec company",
      contactLink: "Contact",
      wholesaleText: "Are you an installer or contractor?",
      wholesaleLink: "See the wholesale offer",
      areas: "Montreal · North Shore · South Shore",
    },
    hero: {
      eyebrow: "A Québec company",
      pills: ["Temperature control", "Solar control", "Privacy"],
      title1: "Regulates the temperature.",
      title2: "Zero gazes from your neighbours.",
      subtitle:
        "Reflective window film installed in just a few hours in Montreal, on the North Shore and the South Shore. You don't have to lift a finger.",
      cta: "Get my free estimate",
      callCta: "438 255 6438",
      areas: "Montreal · North Shore · South Shore",
      reassurance: "Reply within 24 hours • No commitment",
      satisfaction: "Not satisfied? We come back and fix it at no cost.",
      rating: "5.0/5 · 16 reviews on Google",
    },
    benefitsBar: {
      items: [
        { title: "A clear price before work begins", text: "We measure, we assess, then give you a firm, detailed price, no surprises along the way." },
        { title: "A clean install, period", text: "Bubble-free finish and a respected worksite. Not satisfied? We come back and fix it at no cost." },
        { title: "Honest advice, no pressure", text: "We tell you frankly which film fits, and when you don't need one at all." },
      ],
    },
    solutions: {
      eyebrow: "Our solutions",
      title: "For every problem, a solution.",
      text: "Heat, prying eyes, broken glass: pick your situation and we'll show you the film that solves it.",
      more: "Learn more",
      categories: [
        {
          id: "chaleur",
          label: "Heat & glare",
          cards: [
            { title: "Mirror film", text: "Rejects up to 83% of solar heat and reduces glare, while blocking gazes during the day.", to: "/pellicule-miroir", image: "/images/miroir-effet.webp" },
          ],
        },
        {
          id: "intimite",
          label: "Privacy",
          cards: [
            { title: "Mirror film, by day", text: "Reflective effect: you see outside, no one sees in while it's daylight.", to: "/pellicule-miroir", image: "/images/apres-1.webp" },
            { title: "Frosted film, anytime", text: "A frosted finish that blocks gazes day and night while letting light through.", to: "/pellicule-givree", image: "/images/givre-hero.webp" },
          ],
        },
        {
          id: "securite",
          label: "Safety",
          cards: [
            { title: "Safety film", text: "A transparent film that strengthens the glass and holds shards in place if it breaks.", to: "/pellicules/securite", image: "/images/securite-commerce.webp" },
          ],
        },
      ],
    },
    work: {
      eyebrow: "Our projects",
      title: "Real projects, all over the region.",
      alts: [
        "Large residential window with mirror film installed by Reflectum", "Mirror-effect windows seen from outside, gazes are blocked", "Window with frosted film, privacy in a bright room", "Large filmed window on a modern home, a Reflectum project", "Mirror-effect windows on a home, gazes are blocked", "Full facade with mirror films, a Reflectum project",
      ],
    },
    homeForm: {
      eyebrow: "Free estimate",
      title: "Tell us about your windows.",
      text: "Fill out the form, a member of our team contacts you within 24 to 48 hours with a personalized assessment, no commitment.",
    },
    proof: {
      eyebrow: "Proof in pictures",
      title: "Before. After. In just a few hours.",
      text: "Real homes, real results: windows you could see straight through, turned into a flawless mirror. And on video, the finish up close, zero bubbles, zero peeling.",
      before: "Before",
      after: "After",
      alts: [
        ["Windows without film, you can see straight into the home", "The same windows with mirror film, reflective effect, daytime privacy"],
        ["Windows before installation, clear view inside", "Windows after installation, mirror effect, gazes blocked"],
      ],
    },
    reviews: {
      eyebrow: "Customer reviews",
      title: "What our customers say.",
      leaveReview: "Leave a Google review",
      seeMore: "Read more",
      seeLess: "Show less",
      unit: "reviews",
      onGoogle: "16 reviews on Google",
      emptyTitle: "Find all our reviews on Google.",
      emptyText: "Click below to read our customers' reviews or to share your own experience.",
      emptyCta: "See / leave a Google review",
    },
    problem: {
      eyebrow: "The problem we solve",
      title: "Your windows let in far more than light.",
      text: "Excessive heat, climbing air-conditioning bills, fading furniture, neighbours who see everything. Replacing your windows is expensive, often $15,000 or more.",
      bullets: [
        "Rejects up to 83% of solar heat in summer", "No need for new thermal windows that cost a fortune", "Mirror effect for total daytime privacy", "Reduces glare on screens and TVs", "UV protection, furniture and floors protected",
      ],
      cta: "Let's discuss your project",
    },
    process: {
      eyebrow: "How it works",
      title: "A turnkey service, clean and fast.",
      steps: [
        { n: "01", t: "Free estimate", d: "We assess your windows and your goals, and propose the ideal film." },
        { n: "02", t: "Clear quote", d: "Fixed price, no surprises. You approve, we schedule the installation." },
        { n: "03", t: "Clean installation", d: "Turnkey, precise and fast service. No mess, no dust." },
        { n: "04", t: "Immediate comfort", d: "From the moment it's installed: less heat, more privacy, less glare." },
      ],
    },
    segments: {
      residential: {
        title: "Residential",
        heading: "For your residential spaces",
        desc: "Houses, condos, cottages. Take back comfort at home: less heat, more privacy, no gazes from the street or the neighbours.",
        cta: "Residential estimate",
      },
      commercial: {
        title: "Commercial",
        heading: "For your commercial spaces",
        desc: "Offices, shops, clinics. Improve employee comfort, eliminate screen glare and project a professional image.",
        cta: "Commercial estimate",
      },
    },
    finalCta: {
      eyebrow: "Ready to get started?",
      title: "Get your free estimate within 24 hours.",
      text: "No commitment. A member of our team contacts you, assesses your needs and gives you a clear quote.",
      button: "Get my free estimate",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Everything you need to know before getting started.",
      items: [
        {
          q: "How much does an installation cost?",
          a: "The cost depends mainly on the total glass surface to cover and the film you choose. Our rates are a pleasant surprise for most of our clients. For an exact figure, fill out our form: the estimate is 100% free with no commitment.",
        },
        {
          q: "How long does installation take?",
          a: "Most homes are completed in a single day. For shops and offices, we schedule the installation outside your business hours so your operations are never disrupted.",
        },
        {
          q: "What if I'm not satisfied with the result?",
          a: "We come back, period. If anything doesn't satisfy you after the installation, we fix it at no cost.",
        },
        {
          q: "Which areas do you serve?",
          a: "We serve Montreal, the North Shore and the South Shore. Write to us to confirm your area, the estimate is still free.",
        },
        {
          q: "Does it work at night?",
          a: "The mirror effect follows one simple rule: there must be more light outside than inside. In the evening, if your rooms are lit, the effect fades. Dimming indoor lighting or aiming outdoor lights at the windows helps preserve privacy. For complete peace of mind, close your blinds or curtains at night, or choose the frosted film, which provides total privacy 24/7.",
        },
      ],
      more: "Another question?",
      moreLink: "Write to us, we reply within 24 hours",
    },
    faqMore: {
      eyebrow: "Frequently asked questions",
      title: "The other answers.",
      items: [
        {
          q: "How long does a reflective film last?",
          a: "Our professional films last 15 years and more. They don't yellow, bubble or peel.",
        },
        {
          q: "Do my windows need special maintenance?",
          a: "No. After a curing period of about 30 days, you clean your windows as usual with a soft cloth and a non-abrasive cleaner. No special maintenance required.",
        },
        {
          q: "How does it look from the inside?",
          a: "During the day, the mirror film can leave a slight bluish or silvery sheen depending on the model. The effect is subtle and your rooms keep their brightness, you see outside, no one sees in.",
        },
        {
          q: "Does the mirror effect work at night too?",
          a: "The mirror effect follows one simple rule: there must be more light outside than inside. In the evening, if your rooms are lit, the effect fades. Dimming indoor lighting or aiming outdoor lights at the windows helps preserve privacy. For complete peace of mind, close your blinds or curtains at night, or choose the frosted film, which provides total privacy 24/7.",
        },
        {
          q: "Is it compatible with my sealed (thermal) windows?",
          a: "It depends on the glazing type: on certain glass, a solar film can create a risk of thermal shock. That's why we assess the compatibility of every window before installation, and we'll inform you of any risk before we start.",
        },
      ],
    },
    sticky: "Free estimate",
    meta: {
      pages: {
        home: { title: "Reflectum Pellicule, Reflective Window Films | Montreal", desc: "High-performance reflective window films for homes and businesses in Montreal: daytime privacy, up to 83% solar heat rejected and UV protection. Free estimate." },
        films: { title: "Our Films, Mirror, Frosted & Safety | Reflectum Pellicule", desc: "Three films for your windows: mirror for daytime, frosted for day and night, safety to strengthen glass. Discover the one you need." },
        miroir: { title: "Mirror Film, Total Daytime Privacy | Reflectum Pellicule", desc: "An elegant mirror effect: total daytime privacy, up to 83% of solar heat rejected and UV protection. Professional installation in Montreal." },
        givre: { title: "Frosted Film, Day & Night Privacy | Reflectum Pellicule", desc: "An elegant frosted finish that lets light through while blocking gazes, day and night. Bathrooms, offices, partitions, storefronts." },
        securite: { title: "Safety Window Film, Stronger Glass | Reflectum Pellicule", desc: "Transparent safety film in Montreal: holds glass shards, strengthens windows against breakage and break-ins. Free estimate." },
        services: { title: "Residential & Commercial Services | Reflectum Pellicule", desc: "Window film installation for homes and businesses in Montreal: turnkey, clean service. Free estimate within 24 hours." },
        about: { title: "About Reflectum Pellicule, Montreal", desc: "A Québec company: high-performance reflective films installed with craftsman-level precision." },
        contact: { title: "Free Estimate Within 24 h | Reflectum Pellicule", desc: "Request your free estimate: a member of our team contacts you within 24 to 48 hours. No commitment, Montreal and area." },
        privacy: { title: "Privacy Policy | Reflectum Pellicule", desc: "How Reflectum Pellicule collects, uses and protects your personal information, in compliance with Québec's Law 25." },
        wholesale: { title: "Wholesale Window Film Quebec | Reflectum Pellicule", desc: "Wholesale window film in Quebec: Reflectum Silver 20% and 35% rolls at $450 (500 sq ft, $0.90/sq ft). Stock in Quebec, transparent pricing." },
      },
    },
    wholesale: {
      nav: "Pro / Wholesale",
      bannerText: "Are you an installer, glazier or contractor? Discover our wholesale pricing.",
      bannerCta: "See wholesale offer",
      eyebrow: "Pro / Wholesale",
      heroTitle: "The window film supplier for Québec pros.",
      heroSubtitle: "Transparent pricing, stock in Québec.",
      heroStats: [
        { v: "$0.90", l: "per sq ft, Silver 20% and 35%" },
        { v: "500 sq ft", l: "per roll, 60 in x 100 ft" },
        { v: "In stock", l: "in Québec" },
      ],
      heroCta: "Order / Request a quote",
      forWhomEyebrow: "Who it's for",
      forWhom: [
        "Window film installers", "Glaziers", "Construction & renovation contractors", "Designers", "Retailers",
      ],
      productsEyebrow: "Our rolls",
      productsTitle: "Heat-rejection, UV & Privacy Window Film",
      formatLabel: "Format",
      orderCta: "Order / Request a quote",
      products: [
        {
          name: "Reflectum Silver 20%",
          tagline: "Complete daytime privacy (very pronounced mirror effect)",
          format: "60 in x 100 ft roll (500 sq ft)",
          price: "$450 per roll (that's $0.90/sq ft)",
          specs: [
            "Total solar energy rejected (TSER): about 77–80%, very high thermal protection", "Exterior light reflection: about 57%", "Glare reduction: about 78–82%", "UV protection",
          ],
        },
        {
          name: "Reflectum Silver 35%",
          tagline: "Lighter tint: more natural light, more discreet mirror effect",
          format: "60 in x 100 ft roll (500 sq ft)",
          price: "$450 per roll (that's $0.90/sq ft)",
          specs: [
            "Total solar energy rejected (TSER): about 63–65%, moderate thermal protection", "Exterior light reflection: about 39%", "Glare reduction: about 62–63%", "UV protection",
          ],
        },
      ],
      compareTitle: "Silver 20% or Silver 35%?",
      compareNote: "Approximate values measured on the film alone. Results vary depending on the glazing type.",
      nightNote: "The mirror effect protects privacy during the day; at night, with the lights on inside, the effect reverses.",
      compareRows: [
        { label: "Price per roll", a: "$450 ($0.90/sq ft)", b: "$450 ($0.90/sq ft)" },
        { label: "Total solar energy rejected (TSER)", a: "≈ 77–80%", b: "≈ 63–65%" },
        { label: "Exterior light reflection", a: "≈ 57%", b: "≈ 39%" },
        { label: "Glare reduction", a: "≈ 78–82%", b: "≈ 62–63%" },
        { label: "UV protection", a: "Yes", b: "Yes" },
        { label: "Mirror effect", a: "Very pronounced", b: "More discreet" },
        { label: "Ideal use", a: "South/west exposure, glass roofs, overheating", b: "Maximum brightness, moderate heat" },
      ],
      chooseEyebrow: "Which film to choose?",
      choose20Title: "Choose Silver 20% if:",
      choose20: [
        "The window faces due south or due west, or it's a glass roof", "Overheating is your number-one priority", "You want maximum daytime privacy, with a clearly visible mirror effect from outside", "You're fine with a darker look, comparable to sunglasses",
      ],
      choose35Title: "Choose Silver 35% if:",
      choose35: [
        "You want to keep as much natural light inside as possible", "You prefer a more discreet mirror effect from outside", "Heat is a moderate concern (medium thermal protection, good glare reduction)", "Honest precision: daytime privacy is good, but in a brightly lit room or near the glass, silhouettes can be guessed from outside",
      ],
      chooseHelp: "Not sure which to pick? Contact us, we'll advise you based on your windows' orientation and use.",
      advantagesEyebrow: "Wholesale advantages",
      advantages: ["Transparent pricing", "Stock in Québec", "Technical support"],
      faqEyebrow: "Frequently asked questions",
      faq: [
        { q: "What is the minimum order?", a: "Write to us with your quantities, we'll quickly confirm the terms for each product." },
        { q: "Do you deliver, or is it pickup only?", a: "Stock is in Québec. Delivery or pickup options are confirmed with you at order time." },
        { q: "Do you offer samples?", a: "Write to us at contact@reflectumpellicule.com with the product you're interested in and we'll see what we can do for you." },
        { q: "What are the payment methods?", a: "Payment terms are clearly stated on the quote, before any order." },
      ],
      formTitle: "Order / Request a quote",
      formSubtitle: "Fill out the form, we'll reply with a firm price and availability.",
      form: {
        name: "Full name *",
        namePlaceholder: "John Smith",
        company: "Company *",
        companyPlaceholder: "ABC Glazing Inc.",
        companyType: "Business type *",
        companyTypes: ["Window film installer", "Glazier", "Construction / renovation contractor", "Designer", "Retailer", "Other"],
        neq: "NEQ (optional)",
        neqPlaceholder: "1234567890",
        email: "Email *",
        emailPlaceholder: "john@company.com",
        phone: "Phone *",
        phonePlaceholder: "(514) 555-1234",
        city: "City",
        cityPlaceholder: "Montreal",
        product: "Product *",
        productOptions: ["Reflectum Silver 20%", "Reflectum Silver 35%", "Both"],
        rolls: "Number of rolls *",
        message: "Message (optional)",
        messagePlaceholder: "Quantities, desired timelines, questions...",
        submit: "Send my request",
        sending: "Sending...",
        select: "Select...",
        errorRequired: "Please fill in all required fields.",
        successToast: "Request sent! We'll reply shortly.",
        errorToast: "Error while sending. Please try again or call us.",
        errorGeneric: "Error while sending.",
        successTitle: "Request sent!",
        successText: "Thank you! Our team will reply shortly with a firm price and availability.",
        successAnother: "Send another request",
      },
    },
    films: {
      eyebrow: "Our films",
      title: "Three films. Three answers for your windows.",
      subtitle: "Mirror, frosted or safety: each film answers a specific need. Discover the one that fits your windows.",
      miroirCard: {
        label: "Mirror film",
        short: "Daytime reflective effect: prying eyes stay out, and so do heat and UV rays.",
        cta: "Discover the mirror film",
      },
      givreCard: {
        label: "Frosted film",
        short: "An elegant frosted finish: total privacy day and night, with natural light preserved.",
        cta: "Discover the frosted film",
      },
      securiteCard: {
        label: "Safety film",
        short: "A transparent film that strengthens the glass and holds shards in place if it breaks.",
        cta: "Discover the safety film",
      },
      benefitsEyebrow: "The benefits",
      idealEyebrow: "Ideal for",
      galleryEyebrow: "Installation examples",
      noteEyebrow: "Good to know",
      thumbAlt: "example",
      ctaEyebrow: "Free estimate",
      ctaTitle: "See what it would look like in your home.",
      ctaText: "A member of our team assesses your windows and gives you a clear price, no commitment.",
      ctaButton: "Get my free estimate",
      backTo: "See all films",
      miroirPage: {
        eyebrow: "Mirror film",
        title: "The mirror effect. Total privacy, every day.",
        intro: "From the outside, your windows become an elegant mirror that blocks every gaze. From the inside, the view stays clear and bright. It's our most popular solution for exposed facades, large windows and glass doors.",
        benefits: [
          "Total daytime privacy, no one sees inside", "Rejects up to 83% of solar heat in summer", "UV protection, furniture and floors protected", "Reduces glare on screens and TVs", "Clear view preserved from inside, without darkening your rooms",
        ],
        ideal: [
          "Sun-exposed facades", "Large windows and bay windows", "Glass doors and solariums", "Street-level offices and shops",
        ],
        note: "The mirror effect works during the day, when it's brighter outside than inside. In the evening, we recommend closing blinds or curtains, or combining with a frosted film for 24/7 privacy.",
      },
      givrePage: {
        eyebrow: "Frosted film",
        title: "Soft privacy. Day and night, no exceptions.",
        intro: "An elegant frosted finish that lets natural light through while completely blocking gazes, day and night alike. The frosted film is the ideal solution wherever privacy must never fail.",
        benefits: [
          "Complete privacy 24/7, day and night", "Lets natural light through, rooms stay bright", "Modern, discreet frosted finish with a high-end look", "Blocks gazes without curtains or blinds", "Perfect for bathrooms, bedrooms and workspaces", "Easy maintenance and durability",
        ],
        ideal: [
          "Bathrooms and bedrooms", "Glass front doors", "Offices, clinics and conference rooms", "Interior partitions and commercial storefronts",
        ],
        note: "The frosted film diffuses light instead of blocking it. The result: a bright room that's completely private, even with the lights on in the evening.",
      },
      securitePage: {
        eyebrow: "Safety film",
        title: "Stronger glass. Shards held in place.",
        intro: "Safety film is a transparent film that strengthens the glass and keeps it in place if it breaks. It holds glass shards, makes windows harder to smash, deterring break-ins and smash-and-grab theft, and protects against accidental or storm-related breakage.",
        benefits: [
          "Holds glass shards in place if the pane breaks", "Windows are harder to smash, deters break-ins and smash-and-grab theft", "Protects against accidental or storm-related breakage", "Transparent, changes neither light nor appearance", "Can be combined with mirror or anti-UV film",
        ],
        ideal: [
          "Glass doors and ground-floor windows", "Storefronts and street-level offices", "Windows near play areas", "Areas exposed to storms and high winds",
        ],
        note: null,
      },
    },
    cities: {
      eyebrow: "Areas served",
      cta: "Free estimate in my area",
      items: {
        montreal: {
          name: "Montreal",
          title: "Window film installation in Montreal.",
          intro: "Downtown condo, Plateau duplex or townhome: in Montreal, windows often face the street, and the summer sun hits hard. Our reflective films keep your rooms comfortable and prying eyes outside, without replacing your windows.",
          points: [
            "Daytime privacy even at street level, facing the sidewalk", "Up to 83% of solar heat rejected, a real plus during heat waves", "UV protection: floors, furniture and curtains protected", "Frosted option for day-and-night privacy (bathroom, entryway)",
          ],
          metaDesc: "Reflective window film installation in Montreal: daytime privacy, up to 83% of solar heat rejected and UV protection. Free estimate.",
        },
        laval: {
          name: "Laval",
          title: "Window film installation in Laval.",
          intro: "Between Montreal and the northern suburbs, Laval is home to vast residential neighbourhoods where houses have large sun-exposed windows, and where heat and prying eyes quickly become a problem in summer. Reflectum Pellicule installs its reflective and frosted films across the city: bungalows, condos, waterfront properties and businesses.",
          points: [
            "Houses and bungalows: daytime privacy for rooms facing the street", "Up to 83% of solar heat rejected on large exposed windows", "UV protection: floors and furniture protected from fading", "Frosted film for partitions, bathrooms and storefronts",
          ],
          metaDesc: "Window film installation in Laval: daytime privacy, up to 83% of heat rejected and UV protection. Free estimate within 24 h.",
        },
        longueuil: {
          name: "Longueuil",
          title: "Window film installation in Longueuil.",
          intro: "At the heart of the South Shore, Longueuil combines established residential neighbourhoods with a buzzing downtown. South-facing windows and patio doors let in intense summer heat. Reflectum Pellicule installs reflective and frosted films there, for homes as well as shops and offices.",
          points: [
            "Homes: daytime privacy with mirror film, or day-and-night with frosted", "Up to 83% of solar heat rejected, comfortable rooms during heat waves", "Offices and shops: reduced glare on screens, merchandise protected from UV", "Turnkey, clean and careful service",
          ],
          metaDesc: "Window films in Longueuil, residential and commercial: mirror, heat control, UV, frosted. Free, no-commitment estimate.",
        },
        brossard: {
          name: "Brossard",
          title: "Window film installation in Brossard.",
          intro: "Brossard keeps growing: recent houses with large glazed surfaces, bright condos and busy shops. Those beautiful windows let in a lot of heat, and curious gazes. Reflectum Pellicule installs reflective and frosted films there, residential and commercial, with the same promise everywhere: clean installation and a free estimate.",
          points: [
            "Recent houses and condos: large glazed surfaces gain in comfort", "Up to 83% of solar heat rejected, without darkening your rooms", "Frosted film for front doors, bathrooms and offices", "UV protection: new hardwood floors and furniture protected",
          ],
          metaDesc: "Reflective and frosted window films in Brossard: privacy, up to 83% heat rejected, UV protection. Free estimate in 24–48 h.",
        },
        "rive-nord": {
          name: "North Shore",
          title: "Window film installation on the North Shore.",
          intro: "From Laval to Terrebonne, North Shore homes have large windows, patio doors and sun-filled verandas. Our films reduce summer overheating and give you your privacy back, without touching your windows.",
          points: [
            "Ideal for exposed verandas, solariums and patio doors", "Up to 83% of solar heat rejected", "Mirror effect by day: no one sees inside from the street or the yard", "Frosted option for day-and-night privacy",
          ],
          metaDesc: "Reflective window films on the North Shore (Laval, Terrebonne area): privacy, up to 83% heat rejection, UV protection. Free estimate.",
        },
        "rive-sud": {
          name: "South Shore",
          title: "Window film installation on the South Shore.",
          intro: "From Longueuil to Brossard, South Shore bungalows and cottages enjoy beautiful light, sometimes too much. Our reflective films cut glare and heat while keeping your rooms bright.",
          points: [
            "Less glare on screens and TVs", "Up to 83% of solar heat rejected", "Daytime privacy with mirror effect, or frosted film 24/7", "Free at-home estimate anywhere on the South Shore",
          ],
          metaDesc: "Reflective window films on the South Shore (Longueuil, Brossard area): anti-glare, up to 83% heat rejection, privacy. Free estimate.",
        },
      },
    },
    services: {
      eyebrow: "Our services",
      title: "A film for every need.",
      subtitle:
        "Residential or commercial, old or new, we have the right solution for your windows. Every project is unique, every estimate is free.",
      residential: {
        eyebrow: "Residential",
        title: "Comfort and privacy at home",
        desc: "Houses, condos, cottages, glass doors. Take back control of your light, your indoor temperature and your privacy from the neighbourhood.",
        bullets: [
          "Front and side windows", "Solariums and verandas", "Patio doors and bay windows", "Skylights",
        ],
      },
      commercial: {
        eyebrow: "Commercial",
        title: "Productivity and a professional image",
        desc: "Offices, shops, clinics, restaurants. Create a comfortable environment for your employees and customers while reducing your energy costs.",
        bullets: [
          "Commercial storefronts", "Office buildings", "Clinics and practices", "Interior glass partitions",
        ],
      },
      included: {
        eyebrow: "Turnkey service",
        title: "What's always included.",
        text: "No hidden costs, no surprises. A clean, precise project.",
        cta: "Get my free estimate",
        items: [
          "Free consultation at your home or office", "Precise measurements and a detailed, no-commitment quote", "Supply of high-performance films", "Professional installation by our trained team", "Complete cleaning of surfaces after installation",
        ],
      },
    },
    about: {
      eyebrow: "Our story",
      title: "The energy of a new generation, the precision of a craftsman.",
      intro:
        "Reflectum Pellicule was born from a simple idea: making high-performance reflective films accessible to all Quebecers. Without the inflated prices of a major renovation.",
      cta: "Work with us",
      quote: "\u00ab Our windows, reinvented. \u00bb",
      quoteBy: "The Reflectum team",
      story: {
        eyebrow: "Our story",
        title: "An idea that became a passion.",
        paragraphs: [
          "It all started with a simple idea.", "We were looking for a concrete project to test our ambition. One summer day, suffocated by the heat and tired of the lack of privacy at home, it clicked: we needed a simple and effective solution.", "The idea of reflective films was born.", "What was just a casual conversation turned into an obsession. We tested materials, perfected our technique and launched Reflectum.", "Today, we don't just install films: we cut the heat and protect your privacy.", "We started from a simple idea, and this is only the beginning.",
        ],
      },
      values: {
        eyebrow: "Our values",
        title: "What sets us apart.",
        items: [
          {
            title: "Québec company",
            desc: "A motivated, trained and supervised Québec team. We bring our energy and rigour to your project.",
          },
          {
            title: "Proudly Quebecois",
            desc: "We know the harsh winters, the hot and humid summers, and how much comfort matters in your home. A solution designed for here.",
          },
          {
            title: "Craftsman precision",
            desc: "Every installation is measured, cut and installed with craftsman-level attention to detail. Zero bubbles, zero dust, zero damage.",
          },
          {
            title: "Fair prices, pro service",
            desc: "We offer competitive rates. You save money and you gain comfort.",
          },
        ],
      },
    },
    contact: {
      eyebrow: "Contact",
      title: "Get my free estimate.",
      subtitle:
        "Fill out the form below. A member of our team will contact you within 24 to 48 hours with a personalized assessment, no commitment.",
      info: {
        email: "Email",
        phone: "Phone",
        area: "Service area",
        areaValue: "Montreal, North Shore & South Shore",
        hours: "Opening hours",
        hoursValue: "Mon. – Fri. 8am – 6pm",
        fastEyebrow: "Fast",
        fastTitle: "Reply within 24-48h",
        fastText: "Every request receives an immediate email confirmation.",
      },
      form: {
        name: "Full name *",
        namePlaceholder: "John Smith",
        email: "Email *",
        emailPlaceholder: "john@example.com",
        phone: "Phone *",
        phonePlaceholder: "(514) 555-1234",
        address: "Address (optional)",
        addressPlaceholder: "City or full address",
        propertyType: "Property type *",
        select: "Select...",
        residential: "Residential",
        commercial: "Commercial",
        windowCount: "Approximate number of windows",
        windows: ["1 to 3 windows", "4 to 8 windows", "9 to 15 windows", "16 and more"],
        bestTime: "Best time to reach you",
        times: [
          { label: "AM", sub: "9am – 12pm" },
          { label: "Early PM", sub: "1pm – 5pm" },
          { label: "Late PM", sub: "5pm – 6pm" },
        ],
        message: "Message (optional)",
        messagePlaceholder:
          "Briefly describe your needs, window orientation, any particular constraints...",
        submit: "Send my request",
        sending: "Sending...",
        legal:
          "By submitting this form, you agree to be contacted about your project. We never share your information with third parties.",
        errorRequired: "Please fill in all required fields.",
        successToast: "Request sent! We'll contact you within 24-48h.",
        errorToast: "Error while sending. Please try again or call us.",
        errorGeneric: "Error while sending.",
        successTitle: "Request sent!",
        successText:
          "Thank you for your trust. A member of our team will contact you within 24 to 48 hours with your personalized estimate.",
        successAnother: "Send another request",
      },
    },
    privacy: {
      eyebrow: "Privacy",
      title: "Privacy Policy",
      updated: "Last updated: ",
      blocks: [
        {
          title: "1. Who we are",
          body: [
            "Reflectum Pellicule (\u201cwe\u201d, \u201cour\u201d, \u201cus\u201d) is a Québec company specializing in the installation of reflective window films for homes and businesses in the Greater Montreal area.", "We place great importance on protecting your personal information and are committed to complying with Québec's Act respecting the protection of personal information in the private sector (Law 25).",
          ],
        },
        {
          title: "2. Information we collect",
          body: [
            "When you submit an estimate or contact form on our site, we collect: your first and last name, your email address, your phone number, your postal address or city (optional), the property type (residential or commercial), the approximate number of windows, your preferred contact time, and any message you send us.", "When you leave a review, we collect your name, your city (optional), your rating and the text of your comment.",
          ],
        },
        {
          title: "3. How we use your information",
          body: [
            "Your personal information is used only to: provide you with a personalized estimate for your project, communicate with you by email or phone, schedule an assessment visit or installation, follow up on your project, and improve our services based on your feedback.", "We never sell, rent or share your information with third parties for commercial purposes.",
          ],
        },
        {
          title: "4. Facebook and Meta ads",
          body: [
            "If you contact us through a Facebook or Instagram (Meta) ad, the information you provide in the form is transmitted to us by Meta. We use it only to follow up on your request.", "Meta's collection of your information is governed by Meta's privacy policy.",
          ],
        },
        {
          title: "5. Retention and security",
          body: [
            "Your information is stored on secure servers and protected by reasonable technical and organizational measures to prevent unauthorized access.", "We keep your information for as long as necessary to provide our services and meet our legal obligations, generally up to 3 years after the last contact.",
          ],
        },
        {
          title: "6. Your rights",
          body: [
            "Under Law 25, you have the right to access the personal information we hold about you, to rectify inaccurate, incomplete or ambiguous information, to request the deletion of your information, to withdraw your consent at any time, and to file a complaint with the Commission d'accès à l'information du Québec.", "To exercise these rights, contact us at contact@reflectumpellicule.com.",
          ],
        },
        {
          title: "7. Cookies",
          body: [
            "Our site uses a minimum of cookies necessary for its proper operation (admin login session, display preferences). We do not use third-party advertising tracking cookies.",
          ],
        },
        {
          title: "8. Changes to this policy",
          body: [
            "We may update this privacy policy to reflect changes in our practices or to comply with new legal obligations. Any significant change will be announced on this page with the update date.",
          ],
        },
        {
          title: "9. Personal information protection officer",
          body: [
            "In accordance with Law 25, our personal information protection officer can be reached at: Reflectum Pellicule, contact@reflectumpellicule.com, Greater Montreal, Québec, Canada, 438 255 6438.",
          ],
        },
      ],
    },
  },
};
